export default __webpack_public_path__ + "static/media/user-groups-icon.6d7bfd31.svg";